import React from 'react'
import ReactDOMClient from 'react-dom/client'
import ErrorBoundaryPage from 'pages/ErrorBoundaryPage/ErrorBoundaryPage'
import { start } from 'single-spa'
import singleSpaReact from 'single-spa-react'
import OSRoot from 'app/OSRoot'

const LifeCyclesProps = {
  React,
  ReactDOMClient,
  errorBoundary() {
    return <ErrorBoundaryPage />
  },
}

// NOTE: this will run in WPP OS https://vmlyrc.wpp-stage.os-dev.io/local/8500/sjs/main
const application = singleSpaReact({
  ...LifeCyclesProps,
  rootComponent: OSRoot,
})

export const { bootstrap, mount, unmount } = application

// Only call start() in standalone mode (not inside WPP OS shell)
// The shell handles start() for micro-frontends; calling it here causes
// a race condition where the app mounts before OS context is available.
if (!window.singleSpaNavigate) {
  start()
}
